export default "__VITE_ASSET__CPS_NL33__"